import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing }) => ({
  formContainer: {
    // Override FormInputRow description wrapper max-width for better layout
    '& .descriptionWrapper, & .MuiGrid-root.descriptionWrapper, & [class*="descriptionWrapper"]': {
      maxWidth: spacing(27)
    }
  },
  imageTitle: {
    marginTop: spacing(4)
  },
  imageDivider: {
    marginTop: spacing(3)
  }
}))
